// extracted by mini-css-extract-plugin
export var bubble = "_3t-0";
export var container = "_3t-3";
export var contrastBorder = "_3t-4";
export var greyOut = "_3t-2";
export var initialsWrapper = "_3t-1";
export var large = "_3t-9";
export var medium = "_3t-8";
export var mediumSmall = "_3t-7";
export var mediumSmallMedium = "_3t-c";
export var micro = "_3t-5";
export var small = "_3t-6";
export var tiny = "_3t-b";
export var xTiny = "_3t-a";